import { render, staticRenderFns } from "./RoomCardView.vue?vue&type=template&id=b5df2850"
import script from "./RoomCardView.vue?vue&type=script&lang=js"
export * from "./RoomCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports